<template>
  <div v-cloak>
    <v-title>Detailed Order Summary</v-title>
    <v-dialog
      v-model="financeNotSigned"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>Outstanding Finance Application</v-title>
        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <strong>
                  You have an outstanding Finance Application - please check
                  your email, and sign Finance Application before returning
                  here.
                </strong>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="closePage">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-text v-show="!isDataLoading">
        <v-flex v-if="isValid" xs12>
          <label class="subheading">
            Please click the button below to review your order, if the order is
            correct please acknowledge all terms and conditions below. Note: on
            some mobile devices cannot scroll the order, please download the pdf
            instead.
          </label>
          <v-flex xs12 sm4 text-xs-center>
            <v-btn
              v-show="!isDataLoading"
              color="primary"
              @click="openOrder = true"
            >
              Click to Check Order
            </v-btn>
            <v-btn v-show="!isDataLoading" color="primary" @click="download">
              Download PDF Version
            </v-btn>
          </v-flex>
        </v-flex>

        <v-flex v-else xs12>
          <label class="subheading">
            The email link you have followed to reach here is no longer valid -
            please contact your dealer.
          </label>
        </v-flex>
      </v-card-text>
    </v-card>
    <v-dialog v-model="openOrder" full-width fullscreen persistent>
      <v-card>
        <v-title>Vonex Order</v-title>
        <v-card-actions>
          <v-flex xs12 class="closeBtn">
            <v-btn color="blue darken-1" flat @click.native="openOrder = false">
              Close
            </v-btn>
          </v-flex>
        </v-card-actions>
        <v-card-text>
          <div
            style="
              overflow: auto;
              -webkit-overflow-scrolling: touch;
              height: 1400px;
            "
          >
            <iframe
              id="viewer"
              ref="report"
              style="width: 100%; height: 1400px"
              allowfullscreen
              type="image/png"
            ></iframe>
          </div>
          <!-- <div v-show="isMobile " id="orderHtmlContent"></div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex sm12></v-flex>
    <v-dialog v-model="isDataLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please Stand By
          <br />
          Your Order is being generated
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rejected"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>Order Needs Changes</v-title>
        <v-card-text>
          <v-flex xs12>
            <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
              <vonex-textarea
                ref="rejectMessage"
                v-model="requiredChanges"
                name="rejectMessage"
                :rule="rejected ? 'required' : ''"
                placeholder="Enter required changes - dealer will be notified with details."
                :options="fieldConditions"
              ></vonex-textarea>
              <!-- <v-textarea
                v-model="requiredChanges"
                :error-messages="errors.collect('rejectMessage')"
                name="rejectMessage"
                v-validate="rejected ? 'required' : ''"
                placeholder="Enter required changes - dealer will be notified with details."
              ></v-textarea> -->
            </ValidationObserver>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="primary" @click="sendReject">
            Send Back
            <br />
            to Dealer
          </v-btn>
          <v-btn color="primary" @click.native="rejected = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-text>
        <v-flex v-show="!isValid" sm12 md12 lg12 style="margin-top: 20px">
          <v-alert>Invalid Order Number</v-alert>
        </v-flex>
        <div v-if="isValid">
          <v-flex v-show="!isDataLoading" sm12 md12 lg12>
            <FileUpload
              v-show="rows[0].orderStatus === 1"
              :order-g-u-i-d="$route.params.guid"
            >
              Upload any Required Supporting Documentation
            </FileUpload>
            <terms-conditions
              v-if="rows[0].orderID > 0 && !rejected"
              :signed="isSigned"
              @agreed="setAgree"
              @reject="rejected = true"
            ></terms-conditions>
          </v-flex>
          <v-alert v-show="isSending" type="success">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            Sending Email...
          </v-alert>
          <v-flex sm12 md12 lg12>
            <v-alert v-show="rows[0].orderStatus == 2" type="success">
              You have approved this order. Vonex has been notified.
            </v-alert>
          </v-flex>

          <message-alert :component="summary.message"></message-alert>
        </div>
        <v-flex xs12>
          <v-dialog
            v-model="signing"
            scrollable
            fullscreen
            max-width="800px"
            lazy
          >
            <v-card>
              <v-card-text>
                <signature-pad
                  :edit="isAgreed && rows[0].orderStatus == 1"
                  @cancelSign="cancelSign"
                  @closeModal="closeModal"
                  @signFailed="signFailed"
                >
                  Signature of authorised customer
                </signature-pad>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
        <div id="signPad"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapSummaryActions } =
  createNamespacedHelpers(`orders/summary`);

const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
import { Summary } from '../models/summary';
import Signature from './signature-pad';
import termsConditions from './terms-conditions';
import { httpError } from '../models/httpError';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
import FileUpload from './FileUploader';

export default {
  name: 'OrderApprove',
  components: {
    'signature-pad': Signature,
    termsConditions,
    FileUpload,
  },
  data: function () {
    return {
      isAgreed: false,
      isDataLoading: true,
      isValid: false,
      isSending: false,
      rejected: false,
      requiredChanges: null,
      isSigned: false,
      src: this.loadingTask,
      numPages: undefined,
      openOrder: false,
      HtmlView: true,
      signing: false,
    };
  },
  mounted() {
    let vm = this;
    vm.resetOrder();
    // if (typeof this.$route.params.guid === "undefined") this.isValid = false;
    // else this.isValid = true;

    vm.refreshSummary(this.$route.params.guid)
      .then((data) => {
        vm.populateSummaryPDF('image')
          .then((res) => {
            vm.isDataLoading = false;
            let viewer = document.getElementById('viewer');
            let parent = viewer.parentElement;
            let newViewer = document.createElement('iframe');
            viewer.remove();
            newViewer.setAttribute('src', URL.createObjectURL(res));
            newViewer.style = 'width:100%; height:1400px';
            parent.appendChild(newViewer);
            vm.isValid = true;
          })

          .catch(() => {
            vm.isValid = false;
          });
      })
      .catch((err) => {
        vm.isDataLoading = false;
        vm.isValid = false;
      });
  },
  computed: {
    ...mapOrderState(['summary', 'rows']),
    financeNotSigned() {
      if (
        this.summary.reportView &&
        this.summary.reportView.financeApplications
      ) {
        return (
          this.summary.reportView.financeApplications &&
          !this.summary.reportView.financeApplications
            .map((x) => x.status)
            .every((y) => y == 'Signed')
        );
      } else return false;
    },
    isMobile() {
      return window.innerWidth < 900;
    },
    correctOrder() {
      if (this.$route.params.length > 0) return true;
      else return false;
    },
    options() {
      return {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic',
      };
    },
  },
  methods: {
    ...mapSummaryActions([
      'sendEmail',
      'populateSummary',
      'setMessage',
      'resetSummary',
      'populateSummaryPDF',
    ]),
    ...mapOrderActions(['resetOrder']),
    closePage() {
      window.close();
    },
    refreshSummary(guid) {
      return new Promise((resolve, reject) => {
        this.HTML(guid)
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cancelSign() {
      this.signing = false;
      this.isAgreed = false;
    },
    closeModal() {
      this.isAgreed = true;
      this.isSigned = true;
      this.isDataLoading = false;
      this.signing = false;
      this.setMessage({
        message: 'Order signed and submitted',
        httpStatus: 200,
      });
    },
    signFailed() {
      this.setMessage({
        message: 'Signature not saved',
        httpStatus: 500,
      });
    },
    HTML: function (guid) {
      let vm = this;
      return new Promise((resolve, reject) => {
        vm.populateSummary(guid)
          .then((data) => {
            if (data) {
              // document.getElementById("orderHtmlContent").innerHTML =
              //     data.htmlContent;

              resolve();
              return;
            }
          })
          .catch((err) => {
            if (err === 401) vm.$router.push('/');

            reject(err);
            return;
          });
      });
    },
    download() {
      let vm = this;
      vm.isDataLoading = true;
      vm.populateSummaryPDF('pdf')
        .then((res) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              res,
              `${vm.rows[0].orderID}-VonexOrder.pdf`
            );
            // for all other web browsers, display the converted PDF as iframe
          } else {
            let url = URL.createObjectURL(res);
            let link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.download = `${vm.rows[0].orderID}-VonexOrder.pdf`;

            document.body.appendChild(link);
            link.click();
          }
          vm.isDataLoading = false;
        })
        .catch(() => {});
    },
    EmailOrderSummary() {
      let vm = this;
      vm.isSending = true;
      var orderItems = new Summary();
      // orderItems.to = this.dealer.dealer.dealerEmail; //dealer.email
      orderItems.subject = 'new order';
      orderItems.emailBody =
        document.getElementById('orderHtmlContent').innerHTML;

      vm.sendEmail(orderItems)
        .then(function () {
          vm.isSending = false;
        })
        .catch(function () {
          vm.isSending = false;
        });
    },
    setAgree() {
      this.isAgreed = true;
      this.signing = true;
    },
    scrollFix: function (hashbang) {
      location.href = hashbang;
    },
    sendReject() {
      let vm = this;
      vm.$refs.observer.validate().then((result) => {
        if (result) {
          vm.sendRejectionEmail()
            .then(() => {
              this.rejected = false;
              vm.setMessage(
                new httpError({
                  message: 'Dealer has been notified.',
                  httpStatus: 200,
                })
              );
            })
            .catch(() => {
              vm.setMessage(
                new httpError({
                  message: 'Unable to send, please contact dealer.',
                  httpStatus: 500,
                })
              );
            });
        }
      });
    },
    sendRejectionEmail() {
      return new Promise((resolve, reject) => {
        let vm = this;
        vm.isSending = true;

        var orderItems = new Summary({
          anonymous: true,
        });
        orderItems.to = vm.rows[0].dealerDetails.dealerEmail; //dealer.email
        orderItems.subject = `order ${vm.rows[0].orderID} has been rejected by customer`;
        orderItems.emailBody = `<p>${vm.requiredChanges}</p>`;

        vm.sendEmail(orderItems)
          .then(function () {
            vm.isSending = false;
            resolve();
          })
          .catch(function () {
            vm.isSending = false;
            reject();
          });
      });
    },
  },
};
</script>
<style scoped>
.reportView {
  width: 90vh;
  height: 90vh;
}
.closeBtn {
  position: sticky;
  position: -webkit-sticky;
  top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order {
  width: 100%;
  height: 100%;
}
</style>
